<template>
    <div class="page-title-area bg-13">
        <div class="container">
            <div class="page-title-content">
                <h2>Services Style Two</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Services Style Two</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>